import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmUpload, IconX } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-upload.module.scss.js';

const PageUpload = () => {
  const label = useLabel();
  const upload = useLlm(state => state.upload);
  const mimeTypes = useLlm(state => state.mimeTypes);
  const {
    removeFile,
    addFile,
    hasUploadSupport
  } = useLlm(state => state.actions);
  const hasUpload = hasUploadSupport();
  return hasUpload && jsxs(Fragment, {
    children: [jsxs("div", {
      className: getClassNames(style.upload),
      children: [jsx("div", {
        className: getClassNames(style.ui),
        "aria-label": label('llm.upload'),
        children: jsx(IconLlmUpload, {})
      }), jsx("input", {
        className: getClassNames(style.input),
        type: "file",
        id: "file-input",
        accept: mimeTypes,
        onChange: addFile
      })]
    }), upload && jsxs("button", {
      type: "button",
      className: getClassNames(style.file),
      onClick: () => removeFile(),
      title: upload.file.name,
      children: [jsx("span", {
        children: upload.file.name
      }), jsx(IconX, {}), jsx("img", {
        src: upload.base64,
        alt: ""
      })]
    })]
  });
};

export { PageUpload };
//# sourceMappingURL=page-upload.js.map
